import { axiosSolve, axiosPath } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    product_type_list: []
  },
  mutations: {
    resetState(state) {
      state.product_type_list = [];
    },
    getData(state, data) {
      state.product_type_list = data;
    },
    addType(state, data) {
      state.product_type_list.push(data);
    },
    delType(state, data) {
      let index = state.product_type_list.indexOf(data);
      state.product_type_list.splice(index, 1);
    }
  },
  actions: {
    async SortProductType({ commit, rootState, dispatch }, type_sort_list) {
      let url = rootState.api_urls.fetchProductTypeBack_SortProductType;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: type_sort_list },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        return 2;
      }
    },
    async delType({ commit, rootState, dispatch }, data) {
      let url =
        rootState.api_urls.fetchProductTypeBack_delType + data.product_type_id;
      let res = await dispatch("fetchGeneral/axiosPathDeleteData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return res;
      } else {
        commit("delType", data);
      }
    },
    async editType({ commit, rootState, dispatch }, data) {
      let url =
        rootState.api_urls.fetchProductTypeBack_editType + data.product_type_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: data },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return true;
      }
    },
    async addType({ commit, rootState, dispatch }, data) {
      let url = rootState.api_urls.fetchProductTypeBack_addType;
      let res = await dispatch(
        "fetchGeneral/axiosPathPostData",
        { url, form: data },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("addType", res);
      }
    },
    async getData({ commit, state, dispatch, rootState }) {
      let url =
        rootState.api_urls.fetchProductTypeBack_getData +
        rootState.storeBack.store_detail_id;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("getData", res);
      }
    }
  },
  getters: {}
};
